"use client";
import { jsx } from "react/jsx-runtime";
import { useTracking } from "../../../hooks/useTracking.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { Box } from "@mantine/core";
import parse from "html-react-parser";
import { forwardRef, useState, useEffect } from "react";
import { replacer } from "./Html.helpers.js";
import '../../../assets/Html.css';const root = "_root_e0ah4_2";
const HtmlStyles = {
  root
};
const _Html = forwardRef((props, ref) => {
  const { html: dirtyHtml, variant = "dark", condensed = false, className, mod, ...rest } = props;
  const tracker = useTracking();
  const [parsed, setParsed] = useState(null);
  useEffect(() => {
    setParsed(parse(dirtyHtml, replacer(variant, condensed, tracker)));
  }, [dirtyHtml]);
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...rest,
      className: `${HtmlStyles.root} ${className}`,
      ref,
      component: "span",
      mod: { variant, ...mod },
      children: parsed
    }
  );
});
_Html.displayName = "Html";
const Html = sharedHandler(_Html);
Html.displayName = _Html.displayName;
export {
  HtmlStyles as H,
  Html as default
};
